'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createDisplayableDeliveryInfo;

var _Utils = require('../Utils.js');

var _Utils2 = _interopRequireDefault(_Utils);

var _CurrencyUtils = require('../CurrencyUtils.js');

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _Time = require('../Time.js');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createDisplayableDeliveryInfo(moment, locale, currency, deliveryInfo) {
    var minOrderPrice = currencize(locale, currency, deliveryInfo.minOrderPrice);
    var delayMins = deliveryInfo.delayMins && _Time2.default.humanizeMinutesDuration(deliveryInfo.delayMins, moment);
    var charge = currencize(locale, currency, deliveryInfo.charge);

    return (0, _extends3.default)({}, deliveryInfo, {
        minOrderPrice: minOrderPrice,
        delayMins: delayMins,
        charge: charge
    });
}

function currencize(locale, currency, amount) {
    return _CurrencyUtils2.default.toStr(_Utils2.default.padPrice(amount || 0), currency, locale);
}